import React from "react"
import "./Header.css";
import { translate, getLocale, changeLocale } from "./i18n";
import logo from './logo.svg';
import { getPathWithSlash } from "./utils/functional"
import { SupportedLanguage } from './Models';

const path = getPathWithSlash();

const locale = getLocale();
const localeLabel = locale === "nb" ? "English" : "Norsk";
const changeToLocale: SupportedLanguage = locale === "nb" ? "en" : "nb";

const Header: React.FC = () => {

    return <header className="nb-global-header dx-theme-generic-typography">

        <div className="nb-global-header__container">
            <div className="nb-global-header__logo">
                <a href={path} rel="noopener noreferrer">
                    <img src={logo} alt="logo" />
                </a>
            </div>

            <svg aria-hidden="true" width="133" height="100%" viewBox="0 0 133 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.533203 0L49.4808 61.8864V128H132.684L81.7208 61.8864V0H0.533203Z" fill="#F5F2EB"></path>
            </svg>

            <div className="nb-global-header__menu">
                <div style={{ display: "flex", justifyContent: "flex-end", height: "100%" }}>
                    <a href="https://www.norges-bank.no" className="nb-global-header__link-home">
                        <span>{translate("header.linkToNorgesBankText")}</span>
                        <i className="dx-icon-home"></i>
                    </a>
                    <button aria-label={localeLabel} onClick={() => changeLocale(changeToLocale)} className="nb-global-header__link-home">{localeLabel}</button>
                </div>
            </div>
        </div>
    </header>
};

export default Header;